/* eslint-disable react-hooks/rules-of-hooks */
import { UserInfo } from '@/enums/userInfo';
import { AppUtil, isApp } from '@/utils/appHooks';
import { history, useModel } from '@umijs/max';
import Cookies from 'js-cookie';
import { debounce } from 'lodash';
import { Dispatch, useEffect, useRef } from 'react';

// export const FILE_URL = {
//   PRD: 'https://static.ibox.art',
//   TEST: `https://static-${ENV}.ibox.art`,
//   DEV: `https://static-${ENV}.ibox.art`,
// };
export const getEnv = () => {
  const masterProps = useModel('@@qiankunStateFromMaster');
  return masterProps?.getEnv();
};

export function useDebounce<T extends (args: any) => void>(fn: T, wait = 1000) {
  const func = useRef(fn);
  func.current = fn;
  const debounceWrapper = useRef(
    debounce((args) => func.current?.(args), wait),
  );
  return debounceWrapper.current as unknown as T;
}
/**
 * 批量设置更新
 */
export function useBatchEffect(effect: any, deps?: any, wait = 0) {
  const fn = useDebounce(effect, wait);
  useEffect(fn, deps);
}

export function useWatch<T>(
  value: T,
  fn: (newVal: T, oldVal: T | undefined) => void,
  relyArr: React.DependencyList,
) {
  const oldValue = useRef<T>();
  useBatchEffect(() => {
    fn(value, oldValue.current);
    oldValue.current = value;
  }, [value, ...relyArr]);
}

export const getContentHeight = () => {
  const contentHeight =
    document.documentElement.clientHeight || document.body.clientHeight;
  return contentHeight;
};

export const getCookie = () => {
  const cookie = document.cookie;
  console.log(cookie);
};

export const getLocationParams = (keyWords: string) => {
  const href = window.location.href;
  const query = href.substring(href.indexOf('?') + 1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    // 根据指定的参数名去筛选参数值
    if (pair[0] === keyWords) {
      return decodeURI(pair[1]);
    }
  }
  return '';
};

export function isPC() {
  //@ts-ignore
  if (!process?.browser) return;
  let userAgentInfo = navigator && navigator.userAgent,
    Agents = [
      'Android',
      'iPhone',
      'SymbianOS',
      'Windows Phone',
      'iPad',
      'iPod',
      'rv:1.2.3.4',
      'windows mobile',
      'midp',
    ],
    flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) >= 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

export const checkToken = async () => {
  if (!window.localStorage.getItem('Authorization')) {
    const data: any = await AppUtil.checkToken();
    if (data?.token) {
      window.localStorage.setItem('Authorization', data?.token || '');
    }
  }
  if (isApp()) {
    if (!window.localStorage.getItem('Authorization')) {
      await AppUtil.login();
      return false;
    } else {
      return true;
    }
  }
  return false;
};

export const getToken = () => {
  console.log('isApp()', isApp());
  const token = Cookies.get('token');
  console.log(token, 'token');
  if (token === 'undefined' || token === 'null') return '';
  window.localStorage.setItem('Authorization', token || '');
  return token || '';
};

//通过Cookies 获取deviceId
export const deviceId = () => {
  const deviceId = Cookies.get('deviceId');
  if (deviceId === 'undefined' || deviceId === 'null') return '';
  return deviceId || '';
};

//通过Cookies 获取vesion
export const vesion = () => {
  const vesion = Cookies.get('version');
  if (vesion === 'undefined' || vesion === 'null') return '';
  return vesion || '';
};

export const redirectOpenView = ({
  viewUrl,
  webUrl,
  href,
}: {
  viewUrl: string;
  webUrl?: string;
  href?: string;
}) => {
  if (isApp()) {
    AppUtil.openView({
      url: viewUrl,
    });
  } else {
    if (webUrl) {
      history.push(webUrl!);
    }
    if (href) {
      window.location.href = href;
    }
  }
};

export const getAppInit = async (setTop: Dispatch<number>) => {
  if (isApp()) {
    if (!window.localStorage.getItem('header_safe_distance')) {
      const top = await AppUtil.getHeaderBarHeight();
      setTop(
        Number(top || window.localStorage.getItem('header_safe_distance')),
      );
      window.localStorage.setItem('header_safe_distance', top + '');
    } else {
      setTop(Number(window.localStorage.getItem('header_safe_distance')));
    }
  }
};

//通过Cookies 获取Stage
export const getStage = () => {
  const stage = Cookies.get('stage');
  return stage || '';
};

export const getUserInfo = (): UserInfo => {
  if (window.localStorage.getItem('userInfo')) {
    return JSON.parse(window.localStorage.getItem('userInfo') || '{}');
  }
  return {};
};
